<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import Badge from './ui/badge.svelte';
  import Button from './ui/button.svelte';

  import { cn } from '$lib/utils';

  import type { IconOptions } from './ui/icon/icon.svelte';

  let className: string | undefined = undefined;
  export { className as class };

  export let src: string;
  export let alt: string;
  export let srcset: string | undefined = undefined;
  export let sizes: string | undefined = undefined;
  export let badge: { label: string; icon?: IconOptions };
  export let buttonLabel: string;
  export let showInProductsGrid: boolean | undefined = undefined;

  const dispatch = createEventDispatcher<{ click: undefined }>();
</script>

<div
  role="button"
  tabindex="0"
  class={cn(
    'group relative isolate flex cursor-pointer flex-col justify-between overflow-hidden rounded-md p-4',
    !showInProductsGrid && 'aspect-[2/3]',
    className
  )}
  on:click={() => dispatch('click')}
  {...$$restProps}
>
  <img
    {src}
    {alt}
    {srcset}
    {sizes}
    loading="lazy"
    draggable="false"
    class="absolute inset-0 -z-10 h-full w-full select-none object-cover transition-transform duration-300 motion-safe:group-hover:scale-105"
  />

  <Badge size="md" class="z-10" icon={badge.icon}>{badge.label}</Badge>

  <Button
    name={buttonLabel}
    variant="secondary"
    class="backdrop-blur"
    on:click={(e) => {
      e.stopPropagation();
      dispatch('click');
    }}
  >
    {buttonLabel}
  </Button>
</div>
